module.exports = __webpack_public_path__ + "static/media/image-7.15eb76d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/image-7.jpg
// module id = 71
// module chunks = 0